import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Inbox, Mail, Phone } from "lucide-react";
import AppShell, { useAppUser } from "@/components/AppShell";
import MuralAniversariantes from "@/components/MuralAniversariantes";
import { authApi } from "@/lib/api";

export default function Admin() {
  const { user } = useAppUser() || {};
  const [messages, setMessages] = useState(null);

  useEffect(() => {
    if (!user) return;
    authApi()
      .get("/contact")
      .then((res) => setMessages(res.data.messages))
      .catch(() => setMessages([]));
  }, [user]);

  return (
    <AppShell active="mensagens" requireAdmin>
      <section data-testid="admin-dashboard">
        <h1 className="font-display text-2xl font-bold" data-testid="admin-title">Mensagens de Contato</h1>
        <p className="font-mono text-xs tracking-[0.3em] text-gold mt-2 mb-6" data-testid="admin-messages-label">
          RECEBIDAS PELO SITE {messages ? `(${messages.length})` : ""}
        </p>

        <div className="mb-6">
          <MuralAniversariantes />
        </div>

        {messages === null ? (
          <p className="text-zinc-500 text-sm" data-testid="admin-loading">Carregando mensagens...</p>
        ) : messages.length === 0 ? (
          <div className="flex flex-col items-center gap-4 border border-dashed border-white/15 rounded-2xl py-20 text-zinc-500" data-testid="admin-empty-state">
            <Inbox size={36} />
            <p className="text-sm">Nenhuma mensagem recebida ainda.</p>
          </div>
        ) : (
          <div className="space-y-4">
            {messages.map((m, i) => (
              <motion.article
                key={m.id}
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.05, duration: 0.4 }}
                className="bg-surface border border-white/10 hover:border-gold/30 rounded-2xl p-6 transition-colors"
                data-testid={`admin-message-${i}`}
              >
                <div className="flex flex-wrap items-baseline justify-between gap-2">
                  <h2 className="font-display font-semibold text-lg">{m.name}</h2>
                  <span className="font-mono text-xs text-zinc-500">
                    {new Date(m.created_at).toLocaleString("pt-BR")}
                  </span>
                </div>
                <p className="font-mono text-xs text-gold mt-1">{m.subject}</p>
                <p className="text-sm text-zinc-300 mt-3 leading-relaxed whitespace-pre-wrap">{m.message}</p>
                <div className="mt-4 flex flex-wrap gap-4 text-xs text-zinc-500">
                  <span className="inline-flex items-center gap-1.5"><Mail size={13} /> {m.email}</span>
                  {m.phone && <span className="inline-flex items-center gap-1.5"><Phone size={13} /> {m.phone}</span>}
                </div>
              </motion.article>
            ))}
          </div>
        )}
      </section>
    </AppShell>
  );
}
